import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { Toast } from './../UI/toast/Toast'
import { MR } from '../../actions/condominiumActions'
import { getProvider, updateProvider } from '../../helpers/api/provider'
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes'
import handleErrorMessage from '../../helpers/errors/handleErrorMessage'
import withRedirect from '../../helpers/hoc/withRedirect'
import PageHeader from '../common/PageHeader'
import CreateProviderForm from './CreateProviderForm'
import SupportLink from '../root/support/components/SupportLink'
import { Message, Or, PreloadState } from '../UI/preloading/PreloadState'
import { faInfo } from '@fortawesome/free-solid-svg-icons'

const EditProvider = ({ setRedirectUrl, setRedirect }) => {

    const dispatch = useDispatch();
    const { provider } = useParams();
    const { selectedCondominium, condominium } = useSelector(state => state.condominium);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        let isMounted = true;
        if (provider) {
            (async () => {
                !!isMounted && setIsLoading(true);
                try {
                    const { data } = await getProvider(provider);
                    !!isMounted && setData(data);
                } catch (error) {
                    handleErrorMessage(error);
                    !!isMounted && setError(error);
                } finally {
                    !!isMounted && setIsLoading(false);
                }
            })()
        }
        return () => { isMounted = false; }
    }, [provider])

    const handleSubmitData = async (values) => {
        try {
            setSubmitting(true);
            dispatch(MR());
            const response = await updateProvider(provider, values);
            if (response.code === SUCCESS_RESPONSE.OK) {
                Toast.fire({
                    type: 'success',
                    title: 'Se ha actualizado el proveedor satisfactoriamente.',
                });
                setRedirect(true);
                setRedirectUrl('/dashboard/providers');
            }
        } catch (error) {
            handleErrorMessage(error)
        }
        finally {
            setSubmitting(false);
        }
    }

    useEffect(() => {
        setRedirectUrl(`/dashboard/providers`);
    }, [setRedirectUrl]);

    return <>
        <PageHeader
            title={`Edición de proveedor para el condominio ${condominium ? condominium : ''}`}
            description="Edita la información del proveedor."
            titleTag="h2" className="mb-3" col={{ lg: 9 }}
        >
            <SupportLink />
        </PageHeader>
        <PreloadState cond={!!data} loading={isLoading || submitting} message={submitting ? 'Guardando proveedor...' : ''}>
            <Or value={true}>
                <CreateProviderForm
                    condominiumId={selectedCondominium}
                    handleSubmitData={handleSubmitData}
                    provider={data}
                    setRedirect={setRedirect}
                    setRedirectUrl={setRedirectUrl}
                />
            </Or>
            <Or cond={!!error} value={false}>
                <Or value={true}></Or>
                <Message icon={faInfo} color={'danger'} value={true}>ERROR</Message>
                <Message icon={faInfo} color={'info'} value={false}>No hay datos para mostrar</Message>
            </Or>
        </PreloadState>
    </>
}

export default withRedirect(EditProvider)
